(function(){
  var sec=document.getElementById('complete-system'); if(!sec) return;
  var grid=sec.querySelector('[data-cs-grid]'), foot=sec.querySelector('[data-cs-foot]');
  var cnt=sec.querySelector('[data-cs-count]'), addBtn=sec.querySelector('[data-cs-add]');
  var money=function(p){return '\u20B9'+(p/100).toLocaleString('en-IN');};
  if(!grid.querySelector('.cs-skel')){ sync(); sec.addEventListener('change', function(e){ if(e.target.type==='checkbox') sync(); }); bindAdd(); return; }
  fetch('/recommendations/products.json?product_id='+sec.dataset.pid+'&limit=4&intent=related')
    .then(function(r){return r.json();})
    .then(function(d){
      var ps=(d.products||[]).filter(function(p){return p.available;});
      if(!ps.length){ sec.remove(); return; }
      grid.innerHTML = ps.map(function(p){
        var v=p.variants[0];
        return '<label class="cs-card"><input type="checkbox" data-vid="'+v.id+'" data-price="'+v.price+'">'
          + '<span class="cs-img">'+(p.featured_image?'<img src="'+p.featured_image+'&width=300" alt="" loading="lazy">':'')+'</span>'
          + '<span class="cs-tx"><b>'+p.title+'</b><small>'+(v.title&&v.title!=='Default Title'?v.title+' \u00B7 ':'')+money(v.price)+'</small></span></label>';
      }).join('');
      foot.hidden=false; sync();
    }).catch(function(){ sec.remove(); });
  function sync(){
    var sel=[].slice.call(sec.querySelectorAll('input[type=checkbox]:checked'));
    var tot=sel.reduce(function(a,b){return a+(+b.dataset.price);},0);
    cnt.textContent = sel.length ? sel.length+' selected \u00B7 '+money(tot) : 'Select what you need';
    addBtn.disabled = !sel.length;
  }
  sec.addEventListener('change', function(e){ if(e.target.type==='checkbox') sync(); });
  function bindAdd(){}
  addBtn.addEventListener('click', function(){
    var sel=[].slice.call(sec.querySelectorAll('input[type=checkbox]:checked'));
    if(!sel.length) return;
    addBtn.disabled=true; addBtn.textContent='Adding\u2026';
    fetch('/cart/add.js',{method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify({items:sel.map(function(c){return {id:+c.dataset.vid,quantity:1};})})})
      .then(function(){ window.location='/cart'; })
      .catch(function(){ addBtn.disabled=false; addBtn.textContent='Add selected to cart'; });
  });
})();